import { useState, useEffect } from 'react';

export default function FloatingScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 400);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      onClick={scrollToTop}
      className={`fixed bottom-[72px] left-4 md:bottom-6 md:left-auto md:right-20 z-50 w-11 h-11 flex items-center justify-center bg-background-50 border border-background-200 text-foreground-700 rounded-full shadow-lg hover:bg-background-100 hover:text-foreground-950 hover:scale-105 transition-all duration-300 cursor-pointer ${
        visible ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
      aria-label="Scroll to top"
      title="Scroll to top"
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </button>
  );
}